export enum WF_Screen {
  UnderConstruction = 'underConstruction',
  Login = 'login',
  MainMenu = 'mainMenu',
  PropertiesList = 'propertiesList',
  PropertiesMap = 'propertiesMap',
  PropertyStatusRegistration = 'propertiesStatusRegistration',
  AlertHistory = 'alertHistory',
  AlertHistoryDetails = 'alertHistoryDetails',
  DataSummary = 'dataSummary',
  SystemLaunch = 'systemLaunch',
  UserSearch = 'userSearch',
  ProductListWideArea = 'productListWideArea',
  WorkplaceDetails = 'workplaceDetails',
  BranchSummary = 'branchSummary',
  BusinessSummary = 'businessSummary',
  ProductList = 'productList',
  ListSearch = 'listSearch',
}
